import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有仪器
export const pageList = (getData) => {
  return request({
    url: '/back/tool/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 根据id查询
export const getById = (getData) => {
  return request({
    url: '/back/tool/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id删除
export const deleteById = (getData) => {
  return request({
    url: '/back/tool/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id进行更新
export const updateById = (postData) => {
  return request({
    url: '/back/tool/updateTool',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增仪器
export const addTool = (postData) => {
  return request({
    url: '/back/tool/saveTool',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
